<template>
  <div class="flex flex--center one-whole">
    <tree-display-item
      :title="project.title"
      :favorite="isFavorite"
      :hidden="isHidden"
      :activity="project.agencyActivity"
      :active="isActive(project._id)"
    />
    <project-dropdown
      :item="project"
      :is-favorite="isFavorite"
      @update="update"
    />
  </div>
</template>

<script>
import { defineComponent, ref, inject, onMounted, computed } from 'vue'
import Button from '@akerolabs/akero-vue/src/components/button/Button.vue'
import ProjectDropdown from './dropdowns/ProjectDropdown.vue'
import TreeDisplayItem from './TreeDisplayItem.vue'
import { userHigherThan } from './utils'
export default defineComponent({
  name: 'ProjectItem',
  components: {
    [Button.name]: Button,
    [TreeDisplayItem.name]: TreeDisplayItem,
    [ProjectDropdown.name]: ProjectDropdown,
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const project = ref({})
    const updateData = inject('updateData')
    const checkFavorite = inject('isFavorite')
    const isActive = inject('isActive')
    const isFavorite = ref(checkFavorite(props.item._id))

    const update = async (withFetch = true) => {
      if (!withFetch) {
        project.value = props.item
      } else {
        await updateData()
        project.value = props.item
      }
      isFavorite.value = checkFavorite(props.item._id)
    }

    const isHidden = computed(() => {
      return props.item.hidden && userHigherThan('agencyuser')
    })

    onMounted(() => {
      update(false)
    })

    return {
      project,
      isFavorite,
      isActive,
      isHidden,
      update,
      userHigherThan,
    }
  },
})
</script>

<style lang="scss">
.ak-badge-wrapper {
  .ak-badge + .ak-badge {
    margin-left: -0.35em;
  }
}
</style>
